import AhaAnalytics from 'javascripts/analytics';
import React from 'react';
import renderIf from 'render-if';

import { DynamicTabs } from './DynamicTabs';
import { type Tab } from './types';
import classNames from 'classnames';

type DrawerTabsProps = {
  initialActiveKey: string;
  prefix: string;
  tabs: Tab[];
};

export const DrawerTabs: React.FC<DrawerTabsProps> = ({
  initialActiveKey,
  prefix,
  tabs,
}) => {
  if (!tabs) return null;
  if (tabs.length === 0) return null;

  return (
    <DynamicTabs
      initialActiveKey={initialActiveKey}
      prefix={prefix}
      tabs={tabs}
      renderTab={(tab, renderContext) => {
        return (
          <span
            className={classNames(
              'tw-flex tw-flex-row tw-items-center tw-gap-1',
              // When rendered in a menu, add spacing between the left/right items
              renderContext === 'menu'
                ? 'tw-justify-between tw-w-full tw-min-w-40'
                : ''
            )}
          >
            <span>
              {renderIf(tab.online)(
                <span className='large-circle circle-success' />
              )}
              {renderIf(tab.offline)(
                <span className='large-circle circle-offline' />
              )}
              {tab.title}
              {renderIf(tab.tooltip)(
                <span
                  className='flush-tabs__dot'
                  data-title={tab.tooltip}
                  data-placement={tab.tooltip ? 'top' : null}
                />
              )}
            </span>
            <span>
              {renderIf(tab.count)(
                <span className='badge badge--circle'>{tab.count}</span>
              )}
              {renderIf(tab.success)(
                <span className='circle circle-success' />
              )}
              {renderIf(tab.error)(<span className='circle circle-error' />)}
              {renderIf(tab.promoTryPill)(
                <aha-promo-try-pill
                  font-sizing='medium'
                  pill-size='small'
                  className='ml-1'
                />
              )}
            </span>
          </span>
        );
      }}
      onSelect={tab => {
        if (tab.analytics) {
          AhaAnalytics.track(
            'Feature-7184532222592977849',
            'User changes tab on record',
            tab.analytics
          );
        }
      }}
    />
  );
};
